import React from 'react';
import styles from './icon.module.scss'
import { ReactComponent as Logo } from 'img/logo.svg';
import { ReactComponent as Calendar} from 'img/icon_calendar.svg';
import { ReactComponent as DropDown} from 'img/dropdown.svg';
import { ReactComponent as Search } from "img/icon_search.svg";
import { ReactComponent as Camera } from "img/camera.svg";
import { ReactComponent as Close } from 'img/btn-close.svg';
import { ReactComponent as Close2 } from 'img/btn-close2.svg';
import { ReactComponent as User } from 'img/header-user.svg';
import { ReactComponent as Import } from 'img/header-import.svg';
import { ReactComponent as Pacs } from 'img/header-pacs.svg';
import { ReactComponent as Help } from 'img/header-help.svg';
import { ReactComponent as Setting } from 'img/header-setting.svg';
import { ReactComponent as Logout } from 'img/header-logout.svg';
import { ReactComponent as Sortup } from 'img/sort-up-duotone-solid.svg';
import { ReactComponent as Sortdown } from 'img/sort-light.svg';
import { ReactComponent as Refresh } from "img/header-refresh.svg";
import { ReactComponent as Rightwithoutpoint } from 'img/chevron-right.svg'
import { ReactComponent as Downwithoutpoint } from 'img/chevron-down.svg'
import { ReactComponent as Back } from 'img/back.svg'
import { ReactComponent as Hide } from "img/icon-hide.svg"
import { ReactComponent as Show } from "img/icon-show.svg"

import { ReactComponent as Layout111 } from "img/1-1-1.svg";
import { ReactComponent as Layout_13 } from "img/1-3.svg";
import { ReactComponent as Layout_1_3 } from "img/1_3.svg";
import { ReactComponent as Layout_22 } from "img/2-2.svg";
import { ReactComponent as Layout_23 } from "img/2-3.svg";

import { ReactComponent as Scroll } from 'img/list_common.svg';
import { ReactComponent as Pan } from 'img/list_pan.svg';
import { ReactComponent as Zoom } from 'img/list_zoom.svg';
import { ReactComponent as ResetView } from 'img/list_resetveiw.svg';
import { ReactComponent as SwitchLockAxisCenter} from 'img/list_lock.svg';
import { ReactComponent as ViewReport} from 'img/file-check.svg';
import { ReactComponent as Synchronizing} from 'img/crosshairs.svg';
import { ReactComponent as SegmentManager} from 'img/palette.svg';
import { ReactComponent as Annotation} from 'img/gear.svg';

import { ReactComponent as Undo } from 'img/Undo Icon.svg';
import { ReactComponent as Redo } from 'img/Redo Icon.svg';
import { ReactComponent as Brush } from 'img/Brush.svg';
import { ReactComponent as Eraser } from 'img/Eraser.svg';
import { ReactComponent as checkbox } from 'img/checkbox.svg';
import { ReactComponent as Primary_FFR } from 'img/Primary-FFR.svg';
import { ReactComponent as Edit } from 'img/pen-to-square.svg';
import { ReactComponent as Reset } from 'img/reset.svg';
import { ReactComponent as Sculpt } from 'img/sculpt-icon.svg';
import { ReactComponent as Crop } from 'img/crop-icon.svg';
import { ReactComponent as Outline } from 'img/outline-icon.svg';
import { ReactComponent as Erode } from 'img/Erode.svg';
import { ReactComponent as Dilate } from 'img/Dilate.svg';
import { ReactComponent as Check } from 'img/Check.svg';
import { ReactComponent as CircleCheck } from 'img/Circle Check.svg';

type IconProps = React.SVGProps<SVGSVGElement>;

export const ICON_MAP: Record<string, React.FC<IconProps>> = {
  logo : Logo,
  calendar: Calendar,
  dropdown : DropDown,
  search: Search,
  camera: Camera,
  close: Close,
  modalclose: Close2,
  user : User,
  import : Import,
  pacs : Pacs,
  help : Help,
  setting : Setting,
  logout : Logout,
  sortup : Sortup,
  sortdown : Sortdown,
  refresh : Refresh,
  back : Back,
  show : Show,
  hide : Hide,
  rightwithoutpoint : Rightwithoutpoint,
  downwithoutpoint : Downwithoutpoint,
  segmentManager: SegmentManager,
  report : ViewReport,
  undo: Undo,
  redo: Redo,
  brush: Brush,
  eraser: Eraser,
  checkbox: checkbox,
  primary_FFR: Primary_FFR,
  edit:Edit,
  reset:Reset,
  sculpt: Sculpt,
  crop:Crop,
  outline:Outline,
  erode:Erode,
  dilate:Dilate,
  close2:Close2,
  check:Check,
  circleCheck:CircleCheck,
}

export const TOOL_ICON_MAP: Record<string, React.ReactElement> = {
  calendar : <Calendar className={styles.mode}/>,
  dropdown : <DropDown className={styles.mode}/>,
  search : <Search className={styles.mode}/>,
  layout_111 : <Layout111/>,
  layout_13 : <Layout_13/>,
  layout_1_3 : <Layout_1_3/>,
  layout_22 : <Layout_22/>,
  layout_23 : <Layout_23/>,
  threeDmultiview : <Scroll />,
  singlechamberview : <Scroll />,
  singlecprview : <Scroll />,
  scroll: <Scroll />,
  pan: <Pan />,
  zoom: <Zoom />,
  resetView: <ResetView />,
  brightnessContrast: <Scroll />,
  fitToScreen: <Scroll />,
  oneOnOneResolution: <Scroll />,
  WLPreset: <Scroll />,
  roll: <Scroll />,
  rotateCW90: <Scroll />,
  rotateCCW90: <Scroll />,
  flipHorizontal: <Scroll />,
  flipVertical: <Scroll />,
  resetRotation: <Scroll />,
  projection: <Scroll />,
  length: <Scroll />,
  angle: <Scroll />,
  cobbAngle: <Scroll />,
  openCurve: <Scroll />,
  closedCurve: <Scroll />,
  ellipse: <Scroll />,
  rectangle: <Scroll />,
  pencil: <Scroll />,
  arrow: <Scroll />,
  switchAnnotation: <Annotation />,
  switchMeasurement: <Scroll />,
  switchPatientData: <Scroll />,
  switchDICOMTag: <Scroll />,
  switchCine: <Scroll />,
  copyToClipboard: <Scroll />,
  print: <Scroll />,
  addToReport: <Scroll />,
  switchViewReport: <ViewReport />,
  switchLockAxisCenter: <SwitchLockAxisCenter />,
  thickness: <Scroll />,
  threeDRotate: <Scroll />,
  copySelectToClipboard: <Scroll />,
  rotation: <Scroll />,
  anterior: <Scroll />,
  posterior: <Scroll />,
  left: <Scroll />,
  right: <Scroll />,
  superior: <Scroll />,
  inferior: <Scroll />,
  scissor: <Scroll />,
  keepIsolateComponent: <Scroll />,
  undo: <Scroll />,
  redo: <Scroll />,
  restoreVolume: <Scroll />,
  switchSynchronizingPanel: <Synchronizing />,
  copyAllToClipboard: <Scroll />,
  addSelectToReport: <Scroll />,
  addAllToReport: <Scroll />,
  saveAsSTL: <Scroll />,
  selectShading: <Scroll />,
  switchClippingPlane: <Scroll />,
  switchGrid: <Scroll />,
  resetDisplay: <Scroll />,
  switchSegmentManagerTools: <SegmentManager />,
  saveAsSTLNifTi: <Scroll />,
};
